export const Public_Routes = {
  LOGIN: "login",
};

export const Private_Routes = {
  PRIVATE: "auth",
  HOME: "home",
  PROFILE: "profile",
  AUTHORIZE: "requests-management/:params", // params= /approved?SchedulingChangeRequestId=39&InterruptionRequestId=34

  PAYROLL_NOVELTY_FLOWS: {
    index: "/approval-flows",
    create: "/approval-flows/create",
    edit: "/approval-flows/:id/edit",
  },
  MANAGE_PAYROLL_NOVELTY: {
    index: "/manage-approval-flows/:tab",
  },
  MANAGE_BONUS: {
    index: "/manage-bonus/:tab",
  },

  AUDIT_LOGS: {
    index: "/audit-logs",
    detail: "/audit-logs/:auditLogId",
  },

  OVERTIME_SCHEDULE: {
    index: "/overtime-schedule",
  },
};

export const Employee_Routes = {
  HOME: "home",
  PROFILE: "profile",
};

export const Roles_Routes = {};
